import { render, staticRenderFns } from "./chooseAuditDeptDialog.vue?vue&type=template&id=1770daf2&scoped=true&"
import script from "./chooseAuditDeptDialog.vue?vue&type=script&lang=ts&"
export * from "./chooseAuditDeptDialog.vue?vue&type=script&lang=ts&"
import style0 from "./chooseAuditDeptDialog.vue?vue&type=style&index=0&id=1770daf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770daf2",
  null
  
)

export default component.exports